export function validatePassword(
  password: string,
  confirmPassword: string,
): {
  length: boolean;
  lowercase: boolean;
  match: boolean;
  number: boolean;
  symbol: boolean;
  uppercase: boolean;
} {
  return {
    length: password.length >= 8,
    lowercase: /[a-z]/.test(password),
    match: password === confirmPassword && password.length > 0,
    number: /\d/.test(password),
    symbol: /[^\dA-Za-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
  };
}
